import { computed, ComputedRef } from 'vue'

import { EventDetailId } from '@collector/sportsapi-client-legacy'
import {
  useEvent,
  useEventDetails,
  useEventPeriod,
} from '@desktop/views/Relation/composables'

import { GetEventStatusPeriodLengthMinutes } from '../../../configuration'

export function useEventCurrentPeriodLength(
  getEventStatusPeriodLengthMinutes: GetEventStatusPeriodLengthMinutes,
  extraTimeDetailId?: EventDetailId,
  getEventPeriodStartOffsetMinutes?: GetEventStatusPeriodLengthMinutes,
): {
  currentPeriodLengthMinutes: ComputedRef<number | null>
  currentPeriodStartOffsetMinutes: ComputedRef<number | null>
  extraTimePlayed: ComputedRef<boolean>
} {
  const { event } = useEvent()
  const { periodLengthMinutes, extraPeriodLengthMinutes } = useEventPeriod()
  const { getEventDetailValue } = useEventDetails()

  const extraTimePlayed = computed(() => {
    if (!extraTimeDetailId) return false

    try {
      return !!getEventDetailValue(extraTimeDetailId)
    } catch {
      return false
    }
  })

  const periodParams = computed(() => ({
    statusId: event.value.status_id,
    periodLength: periodLengthMinutes.value,
    extraPeriodLength: extraPeriodLengthMinutes.value,
    extraTimePlayed: extraTimePlayed.value,
  }))

  const currentPeriodLengthMinutes = computed(() =>
    getEventStatusPeriodLengthMinutes(
      periodParams.value.statusId,
      periodParams.value.periodLength,
      periodParams.value.extraPeriodLength,
      periodParams.value.extraTimePlayed,
    ),
  )

  const currentPeriodStartOffsetMinutes = computed(() => {
    if (!getEventPeriodStartOffsetMinutes)
      return currentPeriodLengthMinutes.value

    return getEventPeriodStartOffsetMinutes(
      periodParams.value.statusId,
      periodParams.value.periodLength,
      periodParams.value.extraPeriodLength,
      periodParams.value.extraTimePlayed,
    )
  })

  return {
    currentPeriodLengthMinutes,
    currentPeriodStartOffsetMinutes,
    extraTimePlayed,
  }
}
